import { Country, Currency, DietType, PaymentMethod } from '@calo/types';
class CountryService {
    resolveCountry(country, defaultCountry) {
        return Object.keys(Country).includes(country) ? Country[country] : defaultCountry;
    }
    resolveCurrency(country) {
        switch (country) {
            case Country.SA:
                return Currency.SAR;
            case Country.AE:
                return Currency.AED;
            case Country.KW:
                return Currency.KWD;
            case Country.QA:
                return Currency.QAR;
            case Country.OM:
                return Currency.OMR;
            default:
                return Currency.BHD;
        }
    }
    resolveDietsList(country) {
        switch (country) {
            case Country.SA:
                return [DietType.balanced, DietType.lowCarb];
            case Country.BH:
                return [DietType.balanced, DietType.lowCarb, DietType.vegetarian];
            case Country.KW:
                return [DietType.balanced, DietType.lowCarb, DietType.vegetarian];
            default:
                return [DietType.balanced, DietType.lowCarb, DietType.vegetarian];
        }
    }
    getPaymentMethodList(country) {
        switch (country) {
            case Country.BH:
                return [PaymentMethod.cc, PaymentMethod.benefit];
            case Country.SA:
                return [PaymentMethod.cc, PaymentMethod.mada, PaymentMethod.applePay];
            case Country.KW:
                return [PaymentMethod.cc, PaymentMethod.knet];
            default:
                return [PaymentMethod.cc, PaymentMethod.benefit];
        }
    }
}
export default new CountryService();
